import React from "react";
import { observer } from "mobx-react";
import { CustomersStore, Customer } from "../../../../stores";
import { Modal, Button } from "react-bootstrap";
import { NewEditCustomerForm } from "../../../Clients/Customers/NewEdit/NewEditCustomerForm";

interface IProps {
    customersStore: CustomersStore;
    isOpened: boolean;
    onHideHandler: () => void;
    source: string;
    savedCallback: (customer: Customer) => void;
}

interface IState {

    id: string,
    firstName: string,
    middleName: string,
    lastName: string,
    phone: string,
    email: string,
    address: string,
    comment: string
}

@observer
export class NewCustomerModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            id: "",
            firstName: "",
            middleName: "",
            lastName: "",
            phone: "",
            email: "",
            address: "",
            comment: ""
        };
    }
    private formikSumbitEvent?: () => Promise<any> = undefined;


    onFormChange = (fieldName: string, value: string) => {
        const self = this as any;
        self.setState(() => ({
            [fieldName]: value
        }));

    }

    saveCustomer = (
        firstName: string,
        middleName: string,
        lastName: string,
        phone: string,
        email: string,
        address: string,
        comment: string
    ) => {

        let customer = new Customer();

        customer = Object.assign({}, customer, {
            firstName: firstName,
            middleName: middleName,
            lastName: lastName,
            phone: phone,
            email: email,
            address: address,
            comment: comment
        });

        this.props.customersStore.saveCustomer(customer, this.props.source, this.props.savedCallback);
        console.log(customer);
    }

    render() {
        return <Modal show={this.props.isOpened} size="xl" onHide={this.props.onHideHandler}>
            <Modal.Header closeButton>
                <Modal.Title>Выбор клиента</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <NewEditCustomerForm
                    bindSubmitForm={(submit: () => Promise<any>) => {
                        this.formikSumbitEvent = submit;
                    }}
                    firstName={this.state.firstName}
                    middleName={this.state.middleName}
                    lastName={this.state.lastName}
                    email={this.state.email}
                    address={this.state.address}
                    phone={this.state.phone}
                    comment={this.state.comment}
                    id={this.state.id}
                    saveCustomer={this.saveCustomer}
                />

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.onHideHandler}>
                    Закрыть
          </Button>
                <Button variant="primary" onClick={() => {
                    if (this.formikSumbitEvent != undefined)
                        this.formikSumbitEvent();
                }}>
                    Сохранить
          </Button>
            </Modal.Footer>

        </Modal >
    }
}